import React, { Component } from 'react'

import { Paper, Table, TableBody, TableHead, TablePagination, Theme, Typography } from '@mui/material'
import { createStyles, withStyles, WithStyles } from '@mui/styles'

import { OrganizationRow } from './components/OrganizationRow'

class OrganizationsTable extends Component<OrganizationsTableProps & WithStyles<typeof styles>> {
  shouldComponentUpdate(nextProps: OrganizationsTableProps & WithStyles<typeof styles>) {
    return this.props.organizationsIds !== nextProps.organizationsIds
  }

  render() {
    const { classes, currentPage, limit, search, organizationsIds, onChangePage } = this.props
    const noOrganizationIds = organizationsIds.length === 0
    const handlePageChange = (event: any, page: number) => {
      // Due to a bug of material UI, tables fire this callback on re-renders
      if (Boolean(event)) {
        onChangePage(page)
      }
    }
    if (noOrganizationIds) {
      return (
        <Typography className={classes.noResultsText} component={'h2' as any} variant="h3" gutterBottom>
          {`Sorry, "${search}" didn't provide any result, please search another company`}
        </Typography>
      )
    }
    // TODO: Wait for the real count from back
    const hardcodedCount = limit > organizationsIds.length ? organizationsIds.length : limit * (currentPage + 1) + 1
    return (
      <Paper elevation={2} className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <OrganizationRow />
          </TableHead>
          <TableBody>
            {organizationsIds.map((organizationId) => {
              return <OrganizationRow key={organizationId} organizationId={organizationId} />
            })}
          </TableBody>
        </Table>
        <TablePagination
          count={hardcodedCount}
          rowsPerPage={limit}
          page={currentPage}
          rowsPerPageOptions={[]}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onPageChange={handlePageChange}
        />
      </Paper>
    )
  }
}

export type OrganizationsTableProps = {
  organizationsIds: number[]
  currentPage: number
  limit: number
  search: string
  onChangePage: (nextPage: number) => void
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      width: '100%',
      overflowX: 'auto',
    },
    noResultsText: {
      opacity: 0.3,
      maxWidth: 600,
      marginTop: spacing(4),
    },
    table: {
      tableLayout: 'fixed',
    },
  })

export default withStyles(styles)(OrganizationsTable)
